// @flow

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Flip } from 'react-reveal'

import { LoadingAnimation, ContentSpinner } from '../../components'
import { AppWrapper } from '../../containers'
import { store } from '../../store'
import { ANALYTICS_HELPER, ROUTE_CONSTANTS, HELPER, HISTORY } from '../../utils'
import { storeAction } from '../../store/actions'
import { useLoadMore } from '../../hooks'

const RESET_CATALOG_DOMAIN = (item) => {
	// window.scrollTo(0,0)
	store.dispatch(storeAction.RESET_CATALOG_DOMAIN(item.catalogue_url))
}

function Home() {
	useLoadMore({ storeListing: true })
	let dispatch = useDispatch()
	const { allStores, showLoadingScreen, stores, totalPages, loading, pageNumber, loadMore } =
		useSelector((state) => state.store)
	const { browseStores } = useSelector((state) => state.config)

	useEffect(() => {
		const pathname = HISTORY.location.pathname
		const catalog_url = pathname.slice(1)
		if (!loading && catalog_url !== ROUTE_CONSTANTS.BSECURE_MALL) {
			dispatch(storeAction.STORES_LISTING())
		}
		ANALYTICS_HELPER._screenShift(
			ANALYTICS_HELPER.EVENT_STEPS.SHOP,
			ANALYTICS_HELPER.CATEGORY.SELLER_LIST
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (!HELPER.isEmpty(allStores) && pageNumber === 1) {
			dispatch(storeAction.SET_VISIBLE_STORE_LISTING())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allStores])

	return (
		<AppWrapper
			showBackIcon={browseStores}
			observeBackHistory={false}
			showLangIcon={true}
			showCartIcon={false}
			showAccountDropdown={true}
		>
			{showLoadingScreen ? (
				<LoadingAnimation />
			) : (
				<>
					<div className="catalogContentWrap shopContentWrap pt-4 mt-4">
						<div>
							<div className="productListingWrap productListingSpacing">
								<div className="insideProdListingContainer">
									<div className="product-listing">
										<ul>
											{!HELPER.isEmpty(stores) &&
												stores.map((store, i) => {
													return (
														<Flip top opposite key={i}>
															<li className="col-md-3" key={i}>
																<div className="insidePrdBox">
																	<div className="prdImgBox">
																		<div
																			className="prdMainImg"
																			onClick={() => RESET_CATALOG_DOMAIN(store)}
																		>
																			<img src={store.desktop_logo_url} alt={store.store_name} />
																		</div>
																	</div>
																	<div className="prodShotDetailsWrap">
																		<div className="prodName">
																			<span>{HELPER.titleCase(store.store_name)}</span>
																		</div>
																	</div>
																</div>
															</li>
														</Flip>
													)
												})}
										</ul>

										{totalPages > pageNumber &&
											(loadMore ? <ContentSpinner /> : <div id="flyout-left-container"></div>)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</AppWrapper>
	)
}

export default Home
